import { Route, Routes } from 'react-router-dom';

import { paths } from 'data/routes';

import { List } from 'pages/Catalogue/components/Budget/components/List';

import { Manage } from 'sections/Manage';

import { TabType } from 'components/Tabs';

import { Data } from './components/Data';

// import { Sent } from './components/Sent';

export function Budget(): React.ReactElement {
  const tabs: TabType[] = [
    {
      id: 1,
      title: 'Data',
      content: <Data />,
    },
    // {
    //   id: 2,
    //   title: 'Inviati',
    //   content: <Sent />,
    // },
  ];
  const newBudgetTabs: TabType[] = [
    {
      id: 1,
      title: '',
      content: <Data />,
    },
  ];

  return (
    <Routes>
      <Route path="/">
        <Route index element={<List />} />

        <Route path={`${paths.manage}/:id`} element={<Manage title="Budget" tabs={tabs} />} />
        <Route
          path={paths.add}
          element={<Manage title="Add new budget" tabs={newBudgetTabs} isNew />}
        />
      </Route>
    </Routes>
  );
}
